import React from 'react';
import PhoneInput, { Value } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import clsx from 'clsx';
import { ConfigProvider } from 'antd';
import { defaultPhoneCountry } from '../../../contstant';

import styles from './index.module.scss';

interface PhoneNumberInput {
  size?: SizeType;
  value?: Value;
  onChange?: (phone: Value) => void
  disabled?: boolean;
  placeholder?: string;
}

function AlternativePhoneNumberInput({
  value = '' as Value,
  onChange = () => {},
  disabled = false,
  placeholder = '',
  size = 'middle',
}: PhoneNumberInput): React.ReactNode {
  const { componentDisabled } = ConfigProvider.useConfig();

  const isDisabled = disabled || componentDisabled;

  return (
    <PhoneInput
      className={clsx(styles.inputBlock, size && styles[size])}
      disabled={isDisabled}
      defaultCountry={defaultPhoneCountry}
      name="phone"
      placeholder={placeholder || 'Enter phone number'}
      value={value || '' as Value}
      onChange={(phone) => onChange?.(phone || '' as Value)}
      limitMaxLength
      international
      // readOnly
      onFocus={(e) => e.currentTarget.removeAttribute('readonly')}
    />
  );
}

export default AlternativePhoneNumberInput;
